import styled from '@emotion/styled';
import CaretV2Icon from '../../../SvgIcons/CaretV2';
import { MEDIA_QUERY, COLORS3 as COLORS, SPACING } from '../../../../styles/emotion';
import { fieldHeight, fieldHeightMobile, inputBaseStyles, disabledStyles } from '../../form.styles';

export const StyledCaret = styled(CaretV2Icon)<{ disabled?: boolean }>`
  position: absolute;
  top: ${fieldHeight / 2 - 16 / 2}px;
  ${MEDIA_QUERY.MOBILE} {
    top: ${fieldHeightMobile / 2 - 16 / 2}px;
  }
  right: 13px;
  transform: rotate(90deg);
  transition: all 0.2s ease;
  color: ${COLORS.BLACK_100};
  ${({ disabled }) => disabled && `color: ${COLORS.BLACK_030};`}
`;

export const InputSection = styled.div<{ isHoverTrigger?: boolean }>`
  cursor: pointer;
  position: relative;
  // Add padding when isHoverTrigger is true because we'll be removing margin from DropdownListBox ListBoxContainer
  padding-bottom: ${({ isHoverTrigger }) => (isHoverTrigger ? SPACING.XS : null)};
`;

export const Input = styled.input<{ error?: boolean; isPlaceholder?: boolean }>`
  ${({ error }) => inputBaseStyles(error ? 'error' : '')};
  display: flex;
  justify-content: space-between;
  padding-right: 32px;
  cursor: pointer;
  caret-color: transparent;
  &:disabled {
    ${disabledStyles};
    & ${StyledCaret} {
      color: ${COLORS.BLACK_030};
    }
  }
  ${({ isPlaceholder }) => isPlaceholder && `color: ${COLORS.BLACK_030}`};

  &:focus {
    outline: none;
  }
  height: ${fieldHeight}px;
  ${MEDIA_QUERY.MOBILE} {
    pointer-events: none;
    height: ${fieldHeightMobile}px;
  }
`;

export const Trigger = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${({ disabled }) => disabled && `color: ${COLORS.BLACK_030}`};
`;

export default {
  Input,
  InputSection,
  StyledCaret,
  Trigger,
};
